// Browser Push Notification Utilities
import { doc, onSnapshot } from 'firebase/firestore';
import { db } from '../firebase';

// Request notification permission
export async function requestNotificationPermission() {
  if (!('Notification' in window)) {
    console.log('Browser does not support notifications');
    return false;
  }

  if (Notification.permission === 'granted') {
    return true;
  }

  if (Notification.permission !== 'denied') {
    const permission = await Notification.requestPermission();
    return permission === 'granted';
  }

  return false;
}

// Check if notifications are supported and permitted
export function areNotificationsEnabled() {
  return 'Notification' in window && Notification.permission === 'granted';
}

// Show a browser notification
export function showBrowserNotification(title, options = {}) {
  if (!areNotificationsEnabled()) {
    console.log('Notifications not enabled');
    return;
  }

  const defaultOptions = {
    icon: '/logo192.png',
    badge: '/logo192.png',
    vibrate: [200, 100, 200],
    requireInteraction: true,
    ...options
  };

  // If service worker is available, use it
  if ('serviceWorker' in navigator && navigator.serviceWorker.controller) {
    navigator.serviceWorker.ready.then((registration) => {
      registration.showNotification(title, defaultOptions);
    });
  } else {
    // Fallback to regular notification
    new Notification(title, defaultOptions);
  }
}

// Listen for new notifications in Firestore and show browser notifications
export function startNotificationListener(userId, userProfile) {
  if (!userId) return null;

  // Check if user wants browser notifications (default true)
  if (userProfile?.browserNotifications === false) {
    console.log('Browser notifications disabled for user');
    return null;
  }

  // Listen to notifications collection for this user
  const notificationsRef = doc(db, 'users', userId);
  
  // We'll use a query to get new notifications
  const { collection, query, where, orderBy, limit, onSnapshot: firestoreOnSnapshot } = require('firebase/firestore');
  
  const notificationsQuery = query(
    collection(db, 'notifications'),
    where('recipientId', '==', userId),
    where('read', '==', false),
    orderBy('createdAt', 'desc'),
    limit(1)
  );

  let isFirstLoad = true;

  const unsubscribe = firestoreOnSnapshot(notificationsQuery, (snapshot) => {
    // Skip the initial load to avoid showing old notifications
    if (isFirstLoad) {
      isFirstLoad = false;
      return;
    }

    snapshot.docChanges().forEach((change) => {
      if (change.type === 'added') {
        const notification = change.doc.data();
        
        // Show browser notification
        showBrowserNotification(notification.title, {
          body: notification.message,
          tag: change.doc.id,
          data: {
            notificationId: change.doc.id,
            url: 'https://refcall.co.za'
          }
        });
      }
    });
  });

  return unsubscribe;
}
